import { render, staticRenderFns } from "./CadastroSegmento.vue?vue&type=template&id=e53d5206&scoped=true&"
import script from "./CadastroSegmento.vue?vue&type=script&lang=js&"
export * from "./CadastroSegmento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53d5206",
  null
  
)

export default component.exports